require('waypoints/lib/noframework.waypoints.js');
require('@fancyapps/fancybox/dist/jquery.fancybox.js');
import { Loader } from '@googlemaps/loader';
import 'owl.carousel';
import { setCookie } from '@trepanation-pray/cookie';
/*eslint-disable */
import {
  weasl,
  weaslOpen,
  weaslClose
} from '@trepanation-pray/weasl/src/weasl.js';


export default {
  init() {
    /*eslint-disable */
    // Keep track so we can restore on close
    // Track moved mounts so we can restore on close (supports many popups)
    const F24_MOVES = new Map();

    document.body.addEventListener('click', (event) => {
      const btn = event.target.closest('.j-header-pop-up');
      if (!btn) return;

      // Unique name per open (or use data-name on the button)
      const name = btn.dataset.popName || `header-pop-up-${Date.now()}-${Math.random().toString(36).slice(2)}`;

      // The hidden stash next to the button
      const stash = btn.previousElementSibling; // .o-page-header__pop-up
      if (!stash) return;

      // Grab "content" HTML safely (normal HTML is fine to copy)
      const contentEl = stash.querySelector('.o-page-header__pop-up-content');
      const contentHTML = contentEl ? contentEl.innerHTML : '';

      // Find a Force24 mount inside your form area (optional)
      const formEl = stash.querySelector('.o-page-header__pop-up-form');
      const f24Mount = formEl
        ? (formEl.querySelector('f24-form') || formEl.querySelector('[role="f24-form"]'))
        : null;

      // If there’s a form mount, prep placeholder so we can restore later
      let placeholder = null;
      if (f24Mount && f24Mount.parentNode) {
        placeholder = document.createComment('f24 mount placeholder');
        f24Mount.parentNode.insertBefore(placeholder, f24Mount);
        F24_MOVES.set(name, { mount: f24Mount, placeholder });
      }

      // Register handlers BEFORE opening (weaslBuilt is fired synchronously)
      const onBuilt = () => {
        document.removeEventListener('weaslBuilt', onBuilt);
        const overlay = document.querySelector(`.weasl[data-name="${name}"]`);
        if (!overlay) return;

        // If we have a form mount, swap the live node into the modal target
        if (f24Mount) {
          const target = overlay.querySelector('.js-f24-modal-form-target');
          if (target) target.replaceWith(f24Mount);
        }
      };

      const onClosed = () => {
        document.removeEventListener('weaslClosed', onClosed);
        const rec = F24_MOVES.get(name);
        if (!rec) return; // no form moved, nothing to restore
        const { mount, placeholder } = rec;
        try {
          placeholder.parentNode.insertBefore(mount, placeholder);
          placeholder.remove();
        } finally {
          F24_MOVES.delete(name);
        }
      };

      document.addEventListener('weaslBuilt', onBuilt, { once: true });
      document.addEventListener('weaslClosed', onClosed, { once: true });

      // Build the modal HTML string:
      // - always include the content block
      // - only include a form target if we actually have a form to move
      const modalInner =
        `<div class="c-header-pop-up">
          <div class="c-header-pop-up__content">${contentHTML}</div>
          ${f24Mount ? '<div class="c-header-pop-up__form js-f24-modal-form-target"></div>' : ''}
        </div>`;

      // Open the modal with our unique name so we can select it onBuilt
      weasl({
        name,
        content: modalInner,
      });
    });


    // Google analytics
    /*eslint-disable */
    // function googleAnalytics() {
    //   var AnalyticsScript = document.createElement('script');
    //   var AnalyticsId = 'GTM-5R7TZT3';
    //   AnalyticsScript.onload = function () {
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag() { dataLayer.push(arguments); }
    //     gtag('js', new Date());
    //     gtag('config', AnalyticsId);
    //   };

    //   AnalyticsScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + AnalyticsId;

    //   document.head.appendChild(AnalyticsScript);
    // }

    // function linkedin() {
    //   (function (l) {
    //     if (!l) {
    //       window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
    //       window.lintrk.q = []
    //     }
    //     var s = document.getElementsByTagName("script")[0];
    //     var b = document.createElement("script");
    //     b.type = "text/javascript"; b.async = true;
    //     b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    //     s.parentNode.insertBefore(b, s);
    //   })(window.lintrk);
    // }


    // function hotjar() {

    //   (function(h,o,t,j,a,r){
    //     h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    //     h._hjSettings={hjid:3644418,hjsv:6};
    //     a=o.getElementsByTagName('head')[0];
    //     r=o.createElement('script');r.async=1;
    //     r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    //     a.appendChild(r);
    //   })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

    // }

    // function leadForensics() {
    //   var script = document.createElement('script');

    //   script.src = 'https://secure.leadforensics.com/js/26933.js';

    //   document.head.appendChild(script);
    // }
    
    // if (getCookie('cookieControlTracking') && getCookie('cookieControlTracking') == 'accept') {
    //   hotjar();
    // }

    // if (getCookie('cookieControlMarketing') && getCookie('cookieControlMarketing') == 'accept') {
    //   linkedin();
    //   leadForensics();
    // }

    // document.addEventListener('cookieAccept', function () {
    //   linkedin();
    //   hotjar();
    //   leadForensics();
    // });

    /*eslint-enable */

    // if (!getCookie('contact-prompt')) {
    //   setTimeout(() => {

    //     document.querySelector('.js-prompt').classList.add('o-contact-prompt--active');


    //   }, 5000)
    // }

    // document.body.addEventListener('click', (event) => {
    //   if (!event.target.matches('.js-prompt__button')) return;
    //   document.querySelector('.js-prompt').classList.remove('o-contact-prompt--active');
    //   setCookie('contact-prompt', 'dismissed', 1, '/');
    // }, false);

    const loader = new Loader({
      apiKey: 'AIzaSyADY5VHjqxdLKtQ7B6iKf9Em59C617UHvQ',
      version: 'weekly',
      libraries: ['places'],
    });


    document.addEventListener('wpcf7mailsent', function (event) {

      console.log();
      if (event.srcElement.parentElement.classList.contains('js-prompt__content')) {
        document.querySelector('.js-prompt').classList.remove('o-contact-prompt--active');
        setCookie('contact-prompt', 'dismissed', 1, '/');
      }
      weaslClose('', 'contact');

      setTimeout(function () {
        weasl({
          name: 'contact-thank-you',
          content: '<h2><span>Thank you</span></h2><p>' + event.detail.apiResponse.message + '</p>',
        });

      }, 500);

    }, false);

    const mapBlocks = document.body.querySelectorAll('.c-map');

    loader.loadCallback(e => {
      if (e) {
        console.log(e);
      } else {

        /*eslint-disable */

        mapBlocks.forEach(mapItem => {

          let mapElement = document.getElementById(mapItem.id);

          let location = JSON.parse(mapItem.dataset.location);

          let latLng = new google.maps.LatLng(location.lat, location.lng);

          let mapOptions = {
            center: latLng,
            zoom: location.zoom,
            disableDefaultUI: true,
          };

          let map = new google.maps.Map(mapElement, mapOptions);

          let icon = {
            path: 'M16.8,48.91C2.63,28.37,0,26.27,0,18.72C0,8.38,8.38,0,18.72,0s18.72,8.38,18.72,18.72 c0,7.55-2.63,9.66-16.8,30.19C19.71,50.25,17.73,50.25,16.8,48.91L16.8,48.91z M18.72,26.52c4.31,0,7.8-3.49,7.8-7.8 s-3.49-7.8-7.8-7.8s-7.8,3.49-7.8,7.8S14.41,26.52,18.72,26.52z',
            fillColor: '#E87722',
            fillOpacity: 1,
            scale: 1,
            strokeWeight: 0,
            size: new google.maps.Size(38, 50),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(19, 50)
          };

          var infowindow = new google.maps.InfoWindow({
            content: '<div class="c-map__info"><h4 class="c-map__info-title">Address</h4><p class="c-map__info-text">' + location.address + '</p></div>',
          });

          let marker = new google.maps.Marker({
            map: mapElement,
            position: latLng,
            icon: icon,
          });

          marker.addListener('click', function () {
            infowindow.open(map, marker);
          });

          marker.setMap(map);
        });

        /*eslint-enable */

      }
    });





    $('.c-accordion__title').click(function () {
      $(this)
        .parents()
        .siblings()
        .removeClass('active')
        .find('.c-accordion__content')
        .slideUp();

      $(this)
        .parent()
        .toggleClass('active');

      $(this)
        .siblings('.c-accordion__content')
        .slideToggle();
    });


    /*eslint-disable */
    $(window).on('load', function () {
      var sliderControls =
        '<div class="c-slider-controls"><div class="c-slider-controls__nav"></div><div class="c-slider-controls__dots"></div></div>';

      $(".o-accreditations").append(sliderControls);

      $(".o-accreditations__list").owlCarousel({
        loop: true,
        items: 1,
        margin: 100,
        autoplay: true,
        autoplaySpeed: 2000,
        autoplayTimeout: 5000,
        center: true,
        autoHeight: false,
        autoplayHoverPause: true,
        nav: false,
        dots: false,
        responsive: {
          540: {
            items: 2,
          },
          720: {
            items: 3,
          },
          960: {
            items: 4,
          },
          1140: {
            items: 5,
          },
          1400: {
            items: 7,
          },
          1600: {
            items: 9,
          }
        }
      });
      $(".o-trusted-partners__content").append(sliderControls);

      $(".o-trusted-partners__list").owlCarousel({
        loop: true,
        items: 1,
        // margin: 100,
        autoplay: true,
        autoplaySpeed: 2000,
        autoplayTimeout: 5000,
        center: true,
        autoHeight: true,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        navContainer: ".o-trusted-partners__content .c-slider-controls__nav",
        dotsContainer: ".o-trusted-partners__content .c-slider-controls__dots",
      });
      $(".b-testimonials__content").each(function () {
  // Create unique slider controls for each block
  const sliderControls = `
    <div class="c-slider-controls">
      <div class="c-slider-controls__nav"></div>
      <div class="c-slider-controls__dots"></div>
    </div>
  `;
  $(this).append(sliderControls);
});

$(".b-testimonials__list").each(function () {
  const $carousel = $(this);
  const itemCount = $carousel.children().length;
  const $dotContainer = $carousel.siblings('.c-slider-controls').find('.c-slider-controls__dots');

  // 🧠 Init listeners *before* Owl starts
  $carousel.on("initialized.owl.carousel", function () {
    setTimeout(function () {
      const $dots = $dotContainer.find(".owl-dot");

      $dots.each(function (index) {
        $(this)
          .attr("aria-label", "Go to slide " + (index + 1))
          .attr("role", "button");

        // This works — force full HTML
        $(this).html('<span>' + (index + 1) + '</span>');
      });
    }, 50); // Small delay helps ensure Owl has finished rendering
  });

  $carousel.on("changed.owl.carousel", function (event) {
    const index = event.item.index;
    const $dots = $dotContainer.find(".owl-dot");

    $dots.each(function (i) {
      $(this).attr("aria-current", i === index ? "true" : "false");
    });
  });

  // 🔁 Init carousel
  $carousel.owlCarousel({
    loop: itemCount > 1,
    items: 1,
    margin: 32,
    nav: false,
    autoplay: itemCount > 1,
    autoplaySpeed: 2000,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    dots: true,
    dotsContainer: $dotContainer
  });
});

      $(".b-card-slider__content").append(sliderControls);

      $(".wp-block-column:last-child() .b-card-slider__list").each(function() {
        $(this).owlCarousel({
          loop: false,
          items: 1,
          margin: 32,
          nav: true,
          dots: false,
          navContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__nav"),
          dotsContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__dots"),
          responsive: {
            650: {
              items: 2,
            },
            780: {
              items: 1,
            },
            960: {
              items: 2,
            },
            1400: {
              items: 3,
            },
          }
        });
      });

      $(".wp-block-column:first-child() .b-card-slider__list").each(function() {
        $(this).owlCarousel({
          loop: false,
          items: 1,
          margin: 32,
          nav: true,
          dots: false,
          rtl: true,
          navContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__nav"),
          dotsContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__dots"),
          responsive: {
            650: {
              items: 2,
            },
            780: {
              items: 1,
            },
            960: {
              items: 2,
            },
            1400: {
              items: 3,
            },
          }
        });
      });

      $(":not(.wp-block-column) .b-card-slider__list").each(function() {
        $(this).owlCarousel({
          loop: false,
          items: 1,
          margin: 32,
          nav: true,
          dots: false,
          navContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__nav"),
          dotsContainer: $(this).closest(".b-card-slider__content").find(".c-slider-controls__dots"),
          responsive: {
            650: {
              items: 2,
            },
            780: {
              items: 1,
            },
            960: {
              items: 2,
            },
            1400: {
              items: 3,
            },
          }
        });
      });
      
    });

    $(document).on("click", ".js-contact__button", function (e) {
      e.preventDefault;
      $(".o-contact-pop-up").toggleClass('is--active');

    });

    // wpcf7.initForm($('.weasl--name-contact form'));
    // $(".js-contact__content")
    // grecaptcha.execute();
    // });
    /*eslint-enable */



    // Waypoint trigger
    var waypointTriggers = document.body.querySelectorAll('.j-waypoint, .is-style-scroll-animated'), i;

    for (i = 0; i < waypointTriggers.length; ++i) {
      /*eslint-disable */
      var waypoint = new Waypoint({
        element: waypointTriggers[i],
        offset: '100%',
        handler: function () {
          setTimeout(() => this.element.classList.add('is-animate'), 250);
        },
      })
      /*eslint-enable */
    }

    // $('.j-open-video').fancybox({
    //   // Options will go here
    // });

    $(document).on('click', '.js-search', function () {
      $(this).toggleClass('is-active');
      $('.c-search-form__content').toggleClass('is-active');
    });

    // JavaScript to be fired on all pages
    $('.o-mobile-navigation-button').click(function () {
      $(this).toggleClass('active');
      $('body').toggleClass('menu-active');
      $('.o-primary-navigation').toggleClass('active');
      $('.banner').toggleClass('active');

      $('.sub-menu').removeClass('active');
    });

    // $('.o-primary-navigation .menu-item-has-children > a').after(
    //   '<div class="show-sub-menu">Show menu</div>'
    // );

    // $('.o-primary-navigation .sub-menu ').prepend(
    //   '<div class="hide-sub-menu">back</div>'
    // );
    $(document).on(
      'click',
      '.o-primary-navigation .show-sub-menu',
      function () {
        $(this).toggleClass('active');
        $(this)
          .siblings('.sub-menu')
          .toggleClass('active');
      }
    );

    $(document).on(
      'click',
      '.o-primary-navigation .hide-sub-menu',
      function () {
        $(this).toggleClass('active');
        $(this)
          .closest('.sub-menu')
          .toggleClass('active');
      }
    );

    // JavaScript to be fired on all pages
    $('.c-footer-accordion__button').click(function () {
      console.log(1);
      $(this).toggleClass('is-active');
      $(this).parent().siblings('.c-footer-accordion__content').slideToggle();

    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js